import { IRowNode } from 'ag-grid-enterprise';

export const getNodeRoute = (
  node: IRowNode,
  { includeItself }: { includeItself: boolean }
): string[] => {
  const route = [];
  let current = node.parent ?? null;
  while (current && current.key !== null) {
    route.unshift(current.key);
    current = current.parent ?? null;
  }
  if (includeItself && node.data?._id) {
    route.push(node.data._id as string);
  }
  return route;
};

const isRoutePrefix = (prefix: string[], route: string[]): boolean =>
  prefix.length <= route.length && prefix.every((key, i) => route[i] === key);

/**
 * Filters routes to the minimal set needed for a full refresh:
 * - removes duplicates (keeps first occurrence)
 * - removes any route that is already covered by an ancestor route in the list
 */
export const deduplicateRoutes = (routes: string[][]): string[][] =>
  routes.filter(
    (route, index, all) =>
      !all.some(
        (other, otherIndex) =>
          otherIndex !== index &&
          isRoutePrefix(other, route) &&
          (other.length < route.length || otherIndex < index)
      )
  );
